import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from '@Store/store'

interface OnboardingState {
  isCompleted?: boolean
  isChargeCanceled?: boolean
  isChargeAccepted?: boolean
  isOnboardingStarted?: boolean
  isOnboardingCanceled?: boolean
  isOnboardingFormSubmitted?: boolean
  isFirstRunLogin?: boolean
  menuItemClicked?: '/onboarding' | '/subscription' | '/settings' | ''
}

const initialState: OnboardingState = {
  isCompleted: undefined,
  isChargeCanceled: false,
  isChargeAccepted: false,
  isOnboardingStarted: false,
  isOnboardingCanceled: false,
  isOnboardingFormSubmitted: false,
  isFirstRunLogin: true,
  menuItemClicked: '',
}

export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    setOnboardingCompleted: (
      state,
      action: PayloadAction<boolean | undefined>,
    ) => {
      state.isCompleted = action.payload
    },
    setChargeCanceled: (state, action) => {
      state.isChargeCanceled = action.payload
    },
    setChargeAccepted: (state, action) => {
      state.isChargeAccepted = action.payload
    },
    setOnboardingStarted: (state, action) => {
      state.isOnboardingStarted = action.payload
    },
    setOnboardingCanceled: (state, action) => {
      state.isOnboardingCanceled = action.payload
    },
    setOnboardingFormSubmitted: (state, action) => {
      state.isOnboardingFormSubmitted = action.payload
    },
    setFirstRunLogin: (state, action) => {
      state.isFirstRunLogin = action.payload
    },
    setMenuItemClicked: (state, action) => {
      state.menuItemClicked = action.payload
    },
  },
})

const { actions, reducer } = onboardingSlice

const useOnboardingState = (): OnboardingState =>
  useSelector((state) => state.onboarding)

const useOnboardingActions = () => {
  const dispatch = useDispatch()

  return {
    setOnboardingCompleted: (payload: boolean | undefined) =>
      dispatch(actions.setOnboardingCompleted(payload)),
    setChargeCanceled: (payload: any) =>
      dispatch(actions.setChargeCanceled(payload)),
    setChargeAccepted: (payload: any) =>
      dispatch(actions.setChargeAccepted(payload)),
    setOnboardingStarted: (payload: any) =>
      dispatch(actions.setOnboardingStarted(payload)),
    setOnboardingCanceled: (payload: any) =>
      dispatch(actions.setOnboardingCanceled(payload)),
    setOnboardingFormSubmitted: (payload: any) =>
      dispatch(actions.setOnboardingFormSubmitted(payload)),
    setFirstRunLogin: (payload: any) =>
      dispatch(actions.setFirstRunLogin(payload)),
    setMenuItemClicked: (payload: any) =>
      dispatch(actions.setMenuItemClicked(payload)),
  }
}

export default reducer
export { useOnboardingActions, useOnboardingState }
